export default function FindMovies({ findMovies ,setSelectedId }) {
  return (
    <ul className="m-4 ">
      {findMovies.map((movie) => {
        return (
          <Movies movie={movie} key={movie.imdbID}  setSelectedId={setSelectedId} />
        );
      })}
    </ul>
  );
}
function Movies({ movie,setSelectedId }) {
  return (
    <li
      className="p-2 rounded-md flex items-start gap-2 mt-4 hover:cursor-pointer hover:bg-background100 "
      onClick={()=>setSelectedId(movie.imdbID)}
    >
      <img
        src={movie.Poster}
        alt={movie.Title}
        className="w-14 h-18 object-cover"
      />
      <div className="space-y-3">
        <h3 className="text-sm">{movie.Title}</h3>
        <p className="text-xs">📅 {movie.Year}</p>
      </div>
    </li>
  );
}
